import React, { Component } from 'react'
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import Icon from "../../common/icon/icon.component.jsx";
import IntervalLabel from "./intervallabel.component.jsx";
import DayOfMonthLabel from "./dayofmonthlabel.component.jsx";
import DayOfWeekLabel from "./dayofweeklabel.component.jsx";
import MonthLabel from "./monthlabel.component.jsx";
import { injectIntl } from 'react-intl'
import LabelHelper from "../../common/LabelHelper.jsx";
const uuidv4 = require('uuid/v4')

class RecurringInvoiceInterval extends Component {

    constructor(props, context) {
        super(props, context)
        const info = this.props.value || {}
        const attr = info.attributes || {}
        this.state = {
            info: info,
            interval: attr.interval || 1,
            intervalType: attr.intervalType || 'monthly',
            month: attr.month || 0,
            dayOfMonth: attr.dayOfMonth || 1,
            dayOfWeek: attr.dayOfWeek || 0,
            invoiceId: this.props.invoiceId || '',
            uniqueId: uuidv4(),
            editable: this.props.editable || false,
            editMode: false,
            hover: false,
            onChange: this.props.onChange || function () { },
        }
        this.triggerEdit = this.triggerEdit.bind(this)
        this.save = this.save.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
    }


    componentWillReceiveProps(nextProps) {
        const info = nextProps.value || {}
        const attr = info.attributes || {}
        this.setState({
            info: info,
            interval: attr.interval || 1,
            intervalType: attr.intervalType || 'monthly',
            month: attr.month || 0,
            dayOfMonth: attr.dayOfMonth || 1,
            dayOfWeek: attr.dayOfWeek || 0,
            invoiceId: nextProps.invoiceId || null,
        })
    }

    componentDidMount() { }

    onMouseEnterHandler() {
        this.setState({
            hover: true
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        });
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    save(event) {
        event.preventDefault()
        AppContext.getApiClient().patch('/invoices/' + this.state.invoiceId, {
            recurringInfo: {
                interval: parseInt(this.state.interval),
                intervalType: this.state.intervalType,
                month: parseInt(this.state.month),
                dayOfMonth: parseInt(this.state.dayOfMonth),
                dayOfWeek: parseInt(this.state.dayOfWeek),
            },
        }).then((r) => {
            this.state.onChange(r.attributes.recurringInfo)
            this.setState({
                info: r.attributes.recurringInfo,
                editMode: false,
            })
        })
    }

    renderText() {
        const info = this.state.info || {}
        const attr = info.attributes || {}
        return <IntervalLabel
            intervalType={attr.intervalType}
            intervalLabel={attr.interval}
            dayOfMonthLabel={<DayOfMonthLabel dayOfMonth={attr.dayOfMonth} />}
            dayOfWeekLabel={<DayOfWeekLabel dayOfWeek={attr.dayOfWeek} />}
            monthLabel={<MonthLabel month={attr.month} />}
        />
    }

    handleFormChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    handleFocus(event) {
        event.target.select()
    }

    render() {
        if (!this.state.info) {
            return ''
        }

        let text = this.renderText()

        if (this.state.editable) {
            const intervalTypes = ['daily', 'weekly', 'monthly', 'yearly']
            const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
            const weekDays = [0, 1, 2, 3, 4, 5, 6]
            const monthDays = []
            for (let i = 1; i < 29; i++) {
                monthDays.push(i)
            }
            monthDays.push(31)

            let link = <a href={'#'} onClick={this.triggerEdit} onMouseEnter={this.onMouseEnterHandler} onMouseLeave={this.onMouseLeaveHandler}>
                {text} <Icon value={'pencil-alt'} className={'ml-1 ' + (!this.state.hover ? 'text-gray' : '')} />
            </a>
            text = <span>
                {link}
                <div className={"dropdown-menu p-4 w-100 " + (this.state.editMode ? 'show' : '')}>
                    <div className="w-100 mb-1">
                        <span className={'mr-3'}>
                            <select className="custom-select w-auto" name={'intervalType'} value={this.state.intervalType} onChange={this.handleFormChange}>
                                {intervalTypes.map(type => <option key={type} value={type}>{LabelHelper.getIntervalTypeLabel(this.props.intl, type)}</option>)}
                            </select>
                        </span>
                        <IntervalLabel
                            intervalType={this.state.intervalType}
                            intervalLabel={<input onFocus={this.handleFocus} style={{ width: '4em' }} className="form-control d-inline" min={1} type={'number'} value={this.state.interval} onChange={this.handleFormChange} name={'interval'} />}
                            dayOfMonthLabel={<select className="custom-select w-auto" name={'dayOfMonth'} value={this.state.dayOfMonth} onChange={this.handleFormChange}>
                                {monthDays.map(day => <option key={day} value={day}>{LabelHelper.getDayOfMonthLabel(this.props.intl, day)}</option>)}
                            </select>}
                            dayOfWeekLabel={<select className="custom-select w-auto" name={'dayOfWeek'} value={this.state.dayOfWeek} onChange={this.handleFormChange}>
                                {weekDays.map(day => <option key={day} value={day}>{LabelHelper.getDayofWeekLabel(this.props.intl, day)}</option>)}
                            </select>}
                            monthLabel={<select className="custom-select w-auto" name={'month'} value={this.state.month} onChange={this.handleFormChange}>
                                {months.map(month => <option key={month} value={month}>{LabelHelper.getMonthLabel(this.props.intl, month)}</option>)}
                            </select>}
                        />
                    </div>
                    <p className="m-0 pt-2">
                        <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                            <Icon value={"arrow-left"} />
                        </button>
                        <button className="btn btn-sm btn-outline-primary ml-2" onClick={this.save}>
                            <Icon value={"save"} />
                        </button>
                    </p>
                </div>
            </span>
        }

        return text
    }

}

export default injectIntl(RecurringInvoiceInterval)





// WEBPACK FOOTER //
// ./src/invoice/recurring/interval.component.jsx